import * as R from 'ramda'

const JOB_INVITATION = 'invite.mail'
const JOB_REMINDER = 'reminder.mail'

const WORKSPACE_INVITATION = 'invite.talent_assessment.mail'
const WORKSPACE_REMINDER = 'reminder.talent_assessment.mail'

const CREATED = 'created'
const INVITED = 'invited'

export const MESSAGES_FIELD = 'messages'

export const DEADLINE_FIELD = 'deadline'
export const KIND_FIELD = 'kind'
export const MESSAGE_FIELD = 'message'
export const RECEIVER_FIELD = 'receiver'
export const SENDER_FIELD = 'sender'
export const SUBJECT_FIELD = 'subject'
export const TEMPLATE_ID_FIELD = 'templateId'

export const JOB_TEMPLATE_MODE = 'job'
export const WORKSPACE_TEMPLATE_MODE = 'workspace'

export const MESSAGE_TYPES = {
  JOB_INVITATION,
  JOB_REMINDER,
  WORKSPACE_INVITATION,
  WORKSPACE_REMINDER,
}

export const JOB_STATUSES = {
  [CREATED]: MESSAGE_TYPES.JOB_INVITATION,
  [INVITED]: MESSAGE_TYPES.JOB_REMINDER,
}

export const WORKSPACE_STATUSES = {
  [CREATED]: MESSAGE_TYPES.WORKSPACE_INVITATION,
  [INVITED]: MESSAGE_TYPES.WORKSPACE_REMINDER,
}

export const getTemplate = state => {
  const { language, status, templates, mode } = state

  return R.find(
    R.both(
      R.propEq('language', language),
      R.propEq(
        'message_type',
        mode === JOB_TEMPLATE_MODE
          ? JOB_STATUSES[status]
          : WORKSPACE_STATUSES[status],
      ),
    ),
  )(templates)
}
